'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthConstants = exports.AuthConstants = (0, _keymirror2.default)({
    AUTH_LOAD: null,
    AUTH_LOAD_SUCCESS: null,
    AUTH_LOAD_FAIL: null,
    AUTH_LOAD_IN_SERVER: null,
    LOGIN: null,
    LOGIN_SUCCESS: null,
    LOGIN_FAIL: null,
    LOGOUT: null,
    LOGOUT_SUCCESS: null,
    LOGOUT_FAIL: null,
    AUTH_RESET_ERROR: null,
    AUTH_RESET: null,
    REFRESH_LOGOUT_SUCCESS: null,
    ONE_CLICK_SUCCESS: null,
    ONE_CLICK_CONFIRM_ERROR: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/auth.js
// module id = 1865
// module chunks = 0